import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  // { path: '', redirectTo: 'rilevazione-home', pathMatch: 'full' }, //FIXME come fare a renderlo valido per le altre PWA
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthPageModule)},
  // tslint:disable-next-line:max-line-length
  { path: 'rilevazione-home', loadChildren: () => import('./rilevazione-home/rilevazione-home.module').then(m => m.RilevazioneHomePageModule),
          canActivate: [AuthGuard]},
  { path: 'avvio-marcatura', loadChildren: () => import('./avvio-marcatura/avvio-marcatura.module').then(m => m.AvvioMarcaturaPageModule),
          canActivate: [AuthGuard]},
  { path: 'delega', loadChildren: () => import('./delega/delega.module').then(m => m.DelegaPageModule),
          canActivate: [AuthGuard]},
  { path: 'impersonamento', loadChildren: () => import('./impersonamento/impersonamento.module').then(m => m.ImpersonamentoPageModule),
          canActivate: [AuthGuard]},
  // tslint:disable-next-line:max-line-length
  { path: 'recupero-presenze', loadChildren: () => import('./recupero-presenze/recupero-presenze.module').then(m => m.RecuperoPresenzePageModule),
          canActivate: [AuthGuard]},
  { path: 'giustifica-assenze', loadChildren: () => import('./giustifica-assenze/giustifica-assenze.module').then(m => m.GiustificaAssenzePageModule),
          canActivate: [AuthGuard]},
  { path: 'gestione-invii', loadChildren: () => import('./gestione-invii/gestione-invii.module').then(m => m.GestioneInviiPageModule),
          canActivate: [AuthGuard]},
  { path: 'debug', loadChildren: () => import('./debug/debug.module').then(m => m.DebugPageModule),
          canActivate: [AuthGuard]},
  { path: 'elenco-presenti', loadChildren: () => import('./elenco-presenti/elenco-presenti.module').then(m => m.ElencoPresentiPageModule),
          canActivate: [AuthGuard]},
  { path: 'insegnamenti', loadChildren: () => import('./insegnamenti/insegnamenti.module').then(m => m.InsegnamentiPageModule),
          canActivate: [AuthGuard]},
  { path: 'mappa-presenze', loadChildren: () => import('./mappa-presenze/mappa-presenze.module').then(m => m.MappaPresenzePageModule),
          canActivate: [AuthGuard]},
  { path: 'marcatura-home', loadChildren: () => import('./marcatura-home/marcatura-home.module').then(m => m.MarcaturaHomePageModule),
          canActivate: [AuthGuard]},
  { path: 'raccolta-presenze', loadChildren: () => import('./raccolta-presenze/raccolta-presenze.module').then(m => m.RaccoltaPresenzePageModule),
          canActivate: [AuthGuard]},
  { path: 'report', loadChildren: () => import('./report/report.module').then(m => m.ReportPageModule),
          canActivate: [AuthGuard]},
  { path: 'storico-marcature', loadChildren: () => import('./storico-marcature/storico-marcature.module').then(m => m.StoricoMarcaturePageModule),
          canActivate: [AuthGuard]},
  { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsPageModule),
          canActivate: [AuthGuard]},
  // tslint:disable-next-line:max-line-length
  { path: 'storico-marcature-per-ar', loadChildren: () => import('./storico-marcature-per-ar/storico-marcature-per-ar.module').then(m => m.StoricoMarcaturePerArPageModule),
          canActivate: [AuthGuard]},
  // tslint:disable-next-line:max-line-length
  { path: 'storico-rilevazioni', loadChildren: () => import('./storico-rilevazioni/storico-rilevazioni.module').then(m => m.StoricoRilevazioniPageModule),
          canActivate: [AuthGuard]},
  // tslint:disable-next-line:max-line-length
  { path: 'storico-rilevazioni-per-ar', loadChildren: () => import('./storico-rilevazioni-per-ar/storico-rilevazioni-per-ar.module').then(m => m.StoricoRilevazioniPerArPageModule),
          canActivate: [AuthGuard]},
  { path: 'usa-delega', loadChildren: () => import('./usa-delega/usa-delega.module').then(m => m.UsaDelegaPageModule),
          canActivate: [AuthGuard]},
  { path: 'idoneita', loadChildren: () => import('./idoneita/idoneita.module').then(m => m.IdoneitaPageModule),
          canActivate: [AuthGuard]},
  // tslint:disable-next-line:max-line-length
  { path: 'idoneita-studenti', loadChildren: () => import('./idoneita-studenti/idoneita-studenti.module').then(m => m.IdoneitaStudentiPageModule),
          canActivate: [AuthGuard]},
  { path: 'idoneita-invia', loadChildren: () => import('./idoneita-invia/idoneita-invia.module').then(m => m.IdoneitaInviaPageModule),
          canActivate: [AuthGuard]},
  { path: 'fromext', loadChildren: () => import('./fromext/fromext.module').then(m => m.FromextPageModule)},
  { path: 'courtesy', loadChildren: () => import('./courtesy/courtesy.module').then(m => m.CourtesyPageModule)},
  { path: 'unf-message', loadChildren: () => import('./unf-message/unf-message.module').then(m => m.UnfMessagePageModule)}
];

@NgModule({
        imports: [RouterModule.forRoot(routes, {
          onSameUrlNavigation: 'reload'
        })],
        exports: [RouterModule]
      })
export class AppRoutingModule { }
